export default __webpack_public_path__ + "static/media/recentIcon.808e73e2.svg";